import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, DatePicker, Select } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { withRouter } from 'react-router-dom';
//import ExportCSVFoottraffik from "../../components/ExportCSVFoottraffik";
import { get, isEmpty } from 'lodash';
import ExportReportMenu from './ExportReportMenu';

// Global styles
import moment from 'moment';
import { filterByDate } from '../../utils';
import AdvertiserFilter from '../../../../shared/AdvertiserFilter';

const { RangePicker } = DatePicker;

const styles = {
  row: {
    borderRight: '0.8px solid #e8e8e8',
    borderLeft: '0.8px solid #e8e8e8',
    backgroundColor: '#FAFAFA',
    paddingBottom: '10px',
    paddingTop: '10px',
  },
  buttonL: {
    fontSize: '14px',
    width: '150px',
    marginRight: '10px',
    height: '36px',
    margin: '12px 10px 12px 0',
  },
  buttonS: {
    width: '100%',
    fontSize: '14px',
  },
  search: {
    fontSize: '14px',
    width: '180px',
    height: '36px',
  },
};

const DropDownOrgToggle = ({ orgs, filteredOrg, setFilteredOrg }) => {
  const options = orgs.map((org) => {
    return { value: org.id, label: org.name };
  });

  return (
    <>
      <Select
        allowClear
        showSearch
        placeholder="Filter by Advertiser"
        onClear={() => {
          setFilteredOrg(null);
        }}
        onChange={(org) => {
          setFilteredOrg({ id: org });
        }}
        options={options}
        filterOption={(input, option) => {
          return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        }}
      />
    </>
  );
};

const SelectCampaignOrder = ({ orgs, selectedCOIds, setSelectedCOIds, campaignOrders }) => {
  const handleChange = (e) => {
    setSelectedCOIds(e);
  };

  const options = campaignOrders.map((c, i) => {
    return {
      value: c.id,
      label: c.name,
    };
  });

  return (
    <Select
      mode="multiple"
      style={{ width: '100%' }}
      placeholder="Filter by Campaign Order"
      value={selectedCOIds}
      onChange={handleChange}
      options={options}
      filterOption={(input, option) => {
        return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      }}
    />
  );
};

DropDownOrgToggle.propTypes = {
  orgs: PropTypes.array,
};

const StoreTypeFilter = ({ storeType, setStoreType }) => {
  const options = [
    { value: 'all', label: 'All' },
    { value: 'medical', label: 'Medical' },
    { value: 'recreational', label: 'Recreational' },
  ];

  return (
    <Select
      style={{ width: '100%' }}
      placeholder="Store Type"
      defaultValue="all"
      value={storeType}
      onChange={(value) => setStoreType(value)}
      options={options}
    />
  );
};

const FiltersBar = withRouter(
  ({
    orgs,
    filteredOrg,
    selectedCOIds,
    setSelectedCOIds,
    campaignOrders,
    onExportWeeklyReport,
    orgConfigAccess,
    reportData,
    bySummaryRangeDate,
    history,
    prepareExport,
    storeType,
    setStoreType,
  }) => {
    //first sort the orgs
    function compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const bandA = a.name.toUpperCase();
      const bandB = b.name.toUpperCase();

      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
    }
    if (orgs && orgs.length > 0) {
      orgs.sort(compare);
    }

    const DateSelector = ({ data }) => {
      // map xAxis dates
      let getDate = reportData.map((a) => a.xAxis);

      // sort them by desc dates
      getDate = getDate.sort(function (a, b) {
        return moment(a).subtract(moment(b));
      });

      // combined start date & end date
      const startEndDate = [moment(getDate[0]), moment(getDate[getDate.length - 1])];

      const setStartAndEndDateParams = (dates) => {
        const params = new URLSearchParams(window.location.search);
        params.delete('startDate');
        params.delete('endDate');

        params.append('startDate', dates[0]);
        params.append('endDate', dates[1]);

        history.push(`/home/analytics/display${params ? `?${params.toString()}` : ''}`);
      };

      return (
        <RangePicker
          style={{ width: '100%' }}
          defaultPickerValue={startEndDate}
          defaultValue={startEndDate}
          value={isEmpty(bySummaryRangeDate) ? startEndDate : bySummaryRangeDate}
          onChange={(v) => {
            console.log([moment(v[0]), moment(v[1])]);
            setStartAndEndDateParams([
              moment(v[0]).format('YYYY-MM-DD'),
              moment(v[1]).format('YYYY-MM-DD'),
            ]);
          }}
        />
      );
    };

    return (
      <Row gutter={[16, 16]}>
        <Col
          xs={24}
          md={{ span: 8, order: 1 }}
          lg={{ span: 6, order: 1 }}
          xl={{ span: 4, order: 1 }}
        >
          {!isEmpty(orgs) && <AdvertiserFilter isSinglePage={true} />}
        </Col>
        <Col
          xs={24}
          md={{ span: 6, order: 2 }}
          lg={{ span: 4, order: 2 }}
          xl={{ span: 3, order: 2 }}
        >
          <StoreTypeFilter storeType={storeType} setStoreType={setStoreType} />
        </Col>
        <Col
          xs={24}
          md={{ span: 11, order: 5 }}
          lg={{ span: 10, order: 5 }}
          xl={{ span: 10, order: 6 }}
        >
          {campaignOrders && campaignOrders.length > 0 && (
            <SelectCampaignOrder
              campaignOrders={campaignOrders}
              selectedCOIds={selectedCOIds}
              setSelectedCOIds={setSelectedCOIds}
            />
          )}
        </Col>
        <Col
          xs={24}
          md={{ span: 10, order: 3 }}
          lg={{ span: 9, order: 3 }}
          xl={{ span: 4, order: 3 }}
        >
          {reportData && reportData.length > 0 && <DateSelector />}
        </Col>
        <Col
          xs={24}
          md={{ span: 4, order: 4 }}
          lg={{ span: 3, order: 4 }}
          xl={{ span: 2, order: 4 }}
        >
          <Button
            style={styles.buttonS}
            shape="round"
            type={'default'}
            onClick={() => {
              setSelectedCOIds([]);
              setStoreType && setStoreType('all');
              const params = new URLSearchParams(window.location.search);
              params.delete('startDate');
              params.delete('endDate');
              params.delete('advertiserId');
              history.push(`/home/analytics/display${params ? `?${params.toString()}` : ''}`);
            }}
            disabled={
              filteredOrg
                ? filteredOrg.id === null && isEmpty(bySummaryRangeDate) && isEmpty(selectedCOIds)
                : false
            }
            icon={<CloseOutlined />}
          >
            Clear
          </Button>
        </Col>
        <Col
          xs={24}
          md={{ span: 4, order: 6 }}
          lg={{ span: 3, order: 6 }}
          xl={{ span: 2, order: 5 }}
        >
          {orgConfigAccess.exportData && (
            <ExportReportMenu
              prepareExport={prepareExport}
              onExportWeeklyReport={onExportWeeklyReport}
            />
          )}
        </Col>
      </Row>
    );
  }
);

FiltersBar.propTypes = {
  orgs: PropTypes.array,
  selectedKey: PropTypes.string,
};

export default FiltersBar;
